import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabsContained";
import { Badge } from "./ui/badge";

const displayCount = (count?: number) =>
  count === undefined || isNaN(count) ? "-" : count.toString();

export type FilterStatus = "published" | "draft" | "all";

interface StatusTableTabProps {
  filterStatus: FilterStatus;
  countByStatus: {
    published: number;
    draft: number;
  };
  onValueChange: (value: FilterStatus) => void;
}

const StatusTableTab = ({
  filterStatus,
  countByStatus,
  onValueChange,
}: StatusTableTabProps) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={filterStatus}
      defaultValue="all"
      onValueChange={(v) => onValueChange(v as FilterStatus)}
    >
      <TabsList>
        <TabsTrigger value="all" className="flex items-center gap-2 text-xs">
          {t("publicationStatusAll")}
          <Badge
            variant={filterStatus === "all" ? "outlinedActive" : "outlined"}
          >
            {displayCount(countByStatus?.published + countByStatus?.draft)}
          </Badge>
        </TabsTrigger>
        <TabsTrigger
          value="published"
          className="flex items-center gap-2 text-xs"
        >
          {t("publicationStatusPublished")}
          <Badge
            variant={
              filterStatus === "published" ? "outlinedActive" : "outlined"
            }
          >
            {displayCount(countByStatus?.published)}
          </Badge>
        </TabsTrigger>
        <TabsTrigger value="draft" className="flex items-center gap-2 text-xs">
          {t("publicationStatusDraft")}
          <Badge
            variant={filterStatus === "draft" ? "outlinedActive" : "outlined"}
          >
            {displayCount(countByStatus?.draft)}
          </Badge>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default StatusTableTab;
